import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "cmi00100-wrapper" }
const _hoisted_2 = { class: "cmi00100-form-area" }
const _hoisted_3 = { class: "q-mb-lg" }
const _hoisted_4 = {
  key: 0,
  class: "cmi00100-password-form"
}
const _hoisted_5 = { class: "row items-center" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  key: 0,
  class: "cmi00100-password-form"
}
const _hoisted_8 = { class: "password-chenger" }
const _hoisted_9 = { class: "col q-mb-sm" }
const _hoisted_10 = { class: "col q-mb-sm" }
const _hoisted_11 = { class: "col q-mb-sm" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import axios from 'axios';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import MemberDetailCard from '../../components/card/MemberDetailCard.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import MessageChip from '../../components/chip/MessageChip.vue';
import { isEmpty } from '../../common/utils/validateUtils';


export default /*@__PURE__*/_defineComponent({
  __name: 'CMI00100',
  setup(__props) {

const router = useRouter();
// パスワード変更フラグ
const isPasswordFlag = ref(false);
// パスワード変更確認フラグ
const isConfirmationFlag = ref(false);
// パスワード変更完了フラグ
const isUpdateFlag = ref(false);
// エラーメッセージ
const errMessage = ref('');
// エラーメッセージフラグ
const errMessageFlag = ref(false);
// 会員情報
const mKaiin = ref({
  approval_stat: '',
  auth_level: '',
  user_id: '',
  user_name_mei: '',
  user_name_sei: '',
  customer_cd: '',
  mail_address: '',
  phone_number: '',
  work_school_name: '',
  affiliation_department_name: '',
  postal_cd: '',
  todohuken_name: '',
  street_address: '',
  quote_request_mail1: '',
  quote_request_mail2: '',
  quote_request_mail3: '',
  quote_request_mail4: '',
  update_timestamp: '',
  user_attribute: '',
});
// 入力値
const inputData = reactive({
  old_password: '',
  new_password: '',
  new_password_conf: '',
});

// パスワードマスキングフラグ
const isPwd1 = ref(true);
// パスワードマスキングフラグ
const isPwd2 = ref(true);
// パスワードマスキングフラグ
const isPwd3 = ref(true);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  errMessageFlag.value = false;
};

/**
 * 会員情報取得
 */
const getMemberInfo = async () => {
  // Loading Start
  Loading.show();
  // 会員情報取得
  await axios
    .post('/cmi001001/memberInfo')
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          mKaiin.value = res.data.mkaiin;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
/**
 * パスワード変更処理
 */
const passChenge = async () => {
  isConfirmationFlag.value = false;
  // Loading Start
  Loading.show();

  errMessage.value = '';
  errMessageFlag.value = false;
  // 変更データ作成
  const formData = new FormData();
  formData.append('old_password', inputData.old_password);
  formData.append('new_password', inputData.new_password);
  formData.append('new_password_conf', inputData.new_password_conf);
  await axios
    .post('/cmi001002/edit-password', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          errMessage.value = '';
          errMessageFlag.value = false;
          isPasswordFlag.value = false;
          // ダイアログ表示
          isUpdateFlag.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          // エラーメッセージ表示
          errMessage.value = common.message;
          errMessageFlag.value = true;
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 初期表示処理
getMemberInfo();

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeaderBanner, null, _createSlots({ _: 2 }, [
      (!isPasswordFlag.value)
        ? {
            name: "title",
            fn: _withCtx(() => [
              _cache[15] || (_cache[15] = _createTextVNode("会員情報"))
            ]),
            key: "0"
          }
        : {
            name: "title",
            fn: _withCtx(() => [
              _cache[16] || (_cache[16] = _createTextVNode("パスワード変更"))
            ]),
            key: "1"
          }
    ]), 1024),
    _createVNode(MessageChip, {
      display: errMessageFlag.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MemberDetailCard, {
        class: "q-mb-lg",
        data: mKaiin.value,
        mode: "memberinfo"
      }, null, 8, ["data"]),
      _createElementVNode("div", _hoisted_3, [
        (!isPasswordFlag.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col text-right q-mr-md" }, [
                  _createElementVNode("label", null, "パスワード")
                ], -1)),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-6" }, "********", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    width: "200px",
                    label: "パスワード変更",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (
                  (isPasswordFlag.value = true),
                    (isPwd1.value = true),
                    (isPwd2.value = true),
                    (isPwd3.value = true),
                    (inputData.old_password = ''),
                    (inputData.new_password = ''),
                    (inputData.new_password_conf = '')
                ))
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_q_form, {
        autofocus: "",
        greedy: "",
        novalidate: "",
        onSubmit: _cache[11] || (_cache[11] = ($event: any) => (isConfirmationFlag.value = true)),
        onValidationError: resetError
      }, {
        default: _withCtx(() => [
          (isPasswordFlag.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", {
                      for: "name",
                      class: "requier password-area"
                    }, "現在のパスワード", -1)),
                    _createVNode(_component_q_input, {
                      id: "old_password",
                      ref: "old_password",
                      modelValue: inputData.old_password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.old_password) = $event)),
                      type: isPwd1.value ? 'password' : 'text',
                      outlined: "",
                      maxlength: "72",
                      name: "old_password",
                      class: "form-control input-area",
                      "th:field": "*{old_password}",
                      dense: "",
                      rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
                      "lazy-rules": "",
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: isPwd1.value ? 'visibility_off' : 'visibility',
                          class: "cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (isPwd1.value = !isPwd1.value))
                        }, null, 8, ["name"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "type", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "requier password-area" }, "変更後のパスワード", -1)),
                    _createVNode(_component_q_input, {
                      id: "new_password",
                      ref: "new_password",
                      modelValue: inputData.new_password,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputData.new_password) = $event)),
                      outlined: "",
                      type: isPwd2.value ? 'password' : 'text',
                      name: "new_password",
                      class: "form-control input-area",
                      maxlength: "72",
                      "th:field": "*{new_password}",
                      dense: "",
                      rules: [
                  (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                  (val) => val !== inputData.old_password || _ctx.$t('validation.same_password'),
                ],
                      "lazy-rules": "",
                      onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: isPwd2.value ? 'visibility_off' : 'visibility',
                          class: "cursor-pointer",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (isPwd2.value = !isPwd2.value))
                        }, null, 8, ["name"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "type", "rules"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "requier password-area" }, "変更後のパスワード（確認用）", -1)),
                    _createVNode(_component_q_input, {
                      id: "new_password_conf",
                      ref: "new_password_conf",
                      modelValue: inputData.new_password_conf,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inputData.new_password_conf) = $event)),
                      outlined: "",
                      type: isPwd3.value ? 'password' : 'text',
                      name: "new_password_conf",
                      class: "form-control input-area",
                      maxlength: "72",
                      "th:field": "*{new_password_conf}",
                      "reactive-rules": "",
                      dense: "",
                      rules: [
                  (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                  (val) => val === inputData.new_password || _ctx.$t('validation.same_new_password'),
                ],
                      "lazy-rules": "",
                      onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: isPwd3.value ? 'visibility_off' : 'visibility',
                          class: "cursor-pointer",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (isPwd3.value = !isPwd3.value))
                        }, null, 8, ["name"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "type", "rules"])
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "pass-info-box" }, " ※パスワードは半角英数字混在の8文字以上で入力してください。 ", -1))
                ]),
                _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
                  "button-area": _withCtx(() => [
                    (!isPasswordFlag.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_component_q_btn, {
                            color: "primary",
                            style: {"width":"200px"},
                            label: "会員情報変更",
                            to: { name: 'memberinfoUpdate' }
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (isPasswordFlag.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_q_btn, {
                            outline: "",
                            style: {"width":"120px","color":"var(--q-delete)"},
                            class: "q-mr-xs back-button",
                            label: "戻る",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => ((isPasswordFlag.value = false), (errMessageFlag.value = false)))
                          }),
                          _createVNode(_component_q_btn, {
                            color: "primary",
                            type: "chenge",
                            style: {"width":"120px"},
                            label: "変更"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
        "button-area": _withCtx(() => [
          (mKaiin.value.auth_level === 'MEMBER' && !isPasswordFlag.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_q_btn, {
                  color: "primary",
                  style: {"width":"200px"},
                  label: "会員情報変更",
                  to: { name: 'memberinfoUpdate' }
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(AlertDialog, {
      display: isConfirmationFlag.value,
      level: "information",
      title: "更新確認",
      text: ['入力された内容で更新します。', 'よろしいですか？'],
      onConfirm: _cache[12] || (_cache[12] = ($event: any) => (passChenge())),
      onClose: _cache[13] || (_cache[13] = ($event: any) => (isConfirmationFlag.value = false))
    }, null, 8, ["display"]),
    _createVNode(AlertDialog, {
      display: isUpdateFlag.value,
      level: "information",
      confirmation: "",
      title: "更新完了",
      text: ['更新が完了しました。'],
      onComplete: _cache[14] || (_cache[14] = ($event: any) => (isUpdateFlag.value = false))
    }, null, 8, ["display"])
  ]))
}
}

})